export default {
      id: "ic-plan-solidarite-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-solidarite-usage",
      toString: function () {
        return this.url;
      }
    }